// Article share row: X, LinkedIn, Facebook, Instagram (native share or copy),
// copy-link, and the device share sheet where the Web Share API exists.
import { $, $$, t, toast } from "./dom.js";

function copyLink(url) {
  const fallback = () => {
    const ta = document.createElement("textarea");
    ta.value = url;
    ta.style.position = "fixed";
    ta.style.opacity = "0";
    document.body.appendChild(ta);
    ta.select();
    try {
      document.execCommand("copy");
      toast(t("copied"));
    } catch (e) {
      toast(t("copyThis") + " " + url);
    }
    document.body.removeChild(ta);
  };
  if (navigator.clipboard && navigator.clipboard.writeText) {
    navigator.clipboard.writeText(url).then(() => toast(t("copied")), fallback);
  } else {
    fallback();
  }
}

const open = (url) => window.open(url, "_blank", "noopener,noreferrer");

export function initShare() {
  const row = $(".js-share");
  if (!row) return;

  const url = row.dataset.url || location.href;
  const text = row.dataset.title || document.title;
  const title = row.dataset.shareTitle || text;
  const eUrl = encodeURIComponent(url);
  const eText = encodeURIComponent(text);
  const nativeShare = () => navigator.share({ title, text, url }).catch(() => {});

  const native = $(".js-share-native", row);
  if (native && navigator.share) native.hidden = false;

  const actions = {
    x: () => open("https://x.com/intent/post?text=" + eText + "&url=" + eUrl),
    linkedin: () => open("https://www.linkedin.com/sharing/share-offsite/?url=" + eUrl),
    facebook: () => open("https://www.facebook.com/sharer/sharer.php?u=" + eUrl),
    instagram: () => {
      if (navigator.share) nativeShare();
      else {
        copyLink(url);
        toast(t("igCopied"));
      }
    },
    link: () => copyLink(url),
    native: nativeShare,
  };

  $$(".js-share-btn", row).forEach((button) => {
    button.addEventListener("click", () => {
      const action = actions[button.dataset.network];
      if (action) action();
    });
  });
}
